import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from '../reducers/auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectAuthUser = createSelector(selectAuthState, (state) => state.user);
export const selectAuthToken = createSelector(selectAuthState, (state) => state.accessToken);
export const selectIsLoggedIn = createSelector(selectAuthState, (state) => state.isLoggedIn);
export const selectAuthLogingIn = createSelector(selectAuthState, (state) => state.logingIn);
export const selectAuthLoading = createSelector(selectAuthState, (state) => state.loadingUser);
export const selectAuthError = createSelector(selectAuthState, (state) => state.error);
